import { render, staticRenderFns } from "./OfficeAllocDraggableTree.vue?vue&type=template&id=ed279f80&scoped=true"
import script from "./OfficeAllocDraggableTree.vue?vue&type=script&lang=ts"
export * from "./OfficeAllocDraggableTree.vue?vue&type=script&lang=ts"
import style0 from "./OfficeAllocDraggableTree.vue?vue&type=style&index=0&id=ed279f80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed279f80",
  null
  
)

export default component.exports